/**
 * Relative-time formatting for the Recent activity timeline (19.4 / plan
 * section 1672) and any other feed on this app that shows "3 minutes ago"
 * instead of a raw timestamp.
 *
 * Ported in spirit from the main app's utils/dateUtils.js formatRelativeTime,
 * but kept self-contained here: this phase's file ownership list gives this
 * agent only utils/formatRelativeTime.js, not utils/dateUtils.js, and the main
 * app's version also pulls in a debugLog helper this app does not have.
 */

// Absolute fallback for anything older than 30 days - a plain localized date,
// so an old timestamp does not print as a triple-digit day count.
function formatAbsoluteDate(date) {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatRelativeTime(dateString) {
  if (!dateString) return 'Never';

  // A bare "YYYY-MM-DD HH:MM:SS" from the server has no timezone marker; treat
  // it as UTC (same rule the main app uses) rather than letting the browser
  // assume local time and skew every timestamp by the viewer's UTC offset.
  const hasTimezone =
    dateString.includes('Z') ||
    dateString.includes('+') ||
    (dateString.includes('-') && dateString.lastIndexOf('-') > 10);
  const date = new Date(hasTimezone ? dateString : `${dateString}Z`);

  if (Number.isNaN(date.getTime())) {
    return 'Invalid date';
  }

  const diffInMs = Math.abs(Date.now() - date.getTime());
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInMinutes < 1) return 'Just now';
  if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
  if (diffInHours < 24) return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
  if (diffInDays < 30) return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  return formatAbsoluteDate(date);
}
